
import Toggle from "../classes/toggle";
import gsap from "gsap";

export default class HamburgerMenu {
	static init() {
		return new HamburgerMenu();
	}

	constructor() {
		this.headermenu = document.querySelector(".headermenu");

		if (this.headermenu === null) return;

		this.element = this.headermenu.querySelector('button[aria-label~="Hamburger"]');

		this.navItems = this.headermenu.querySelectorAll("nav .nav-item");

		this.toggle = new Toggle(this.element, (event, toggle) => {
			if (toggle.pressed() === "true") this.show();
			else this.hide();
		});

		this.navItems.forEach((navItem, i) => {
			const itemPathname = navItem.querySelector("a").pathname.trim();
			const currentPathname = window.location.pathname.trim();

			if (itemPathname === currentPathname)
				navItem.addEventListener("click", () => {
					this.hide();
				});
		});
	}

	show() {
		this.headermenu.classList.add("hamburger-menu-opened");

		this.toggle.pressed(true);
	}

	hide() {
		this.headermenu.classList.remove("hamburger-menu-opened");

		this.toggle.pressed(false);
	}
}